import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import CTAButton from '../../../shared/CTAButton';
import Support from '../../../shared/Support';
import ReturnToMerchant from '../../../shared/ReturnToMerchant';

export default function Recharge({ merchant, session }) {
  const vcInstoreURL = process.env.REACT_APP_VCINSTORE_BASE_URL.replace(
    '%s',
    merchant?.slug,
  );

  return (
    <>
      <div className="text-xl font-avenir-black text-navy-blue mb-4">
        <p className="text-primary-blue text-3xl">
          <FontAwesomeIcon icon={['far', 'thumbs-up']} />
        </p>
        You're good to go!
      </div>

      <div className="max-w-[400px] mx-auto leading-7 ">
        <p>
          Your {merchant.name} rep will be able to see that you're now approved
          for Credit Key{' '}
          {session.hasCustomFlag('instore') ? 'In-Store' : 'Recharge'}. They'll
          be able to place orders on your behalf, using your selected terms.
        </p>
      </div>
      {merchant?.supports_vcinstore ? (
        <CTAButton
          onClick={() => (window.location.href = vcInstoreURL)}
          buttonClass="my-4 max-w-[400px] leading-7 w-3/4 mobile:w-2/3 mx-auto md:w-full bg-primary-blue font-avenir-medium mobile:font-avenir-black tracking-wider text-white rounded-full normal-case mobile:uppercase py-2 mobile:py-3 px-6 text-sm md:text-base inline-block hover:bg-navy-blue flex justify-center items-center"
          buttonText={`Get My ${merchant.name} Virtual Card`}
        />
      ) : (
        <ReturnToMerchant merchant={merchant} />
      )}
      <Support />
    </>
  );
}
